import httpRequest from "../../../infrastructure/httphelper";
import sharedGlobals from "../../../sharedglobals";
class LoginService {
  constructor() {}


  clientLogin(userName, password) {
    let url =
      sharedGlobals.appUrls.securityApiUrl + "api/Security/Authenticate";
    let params = {
      userName: userName,
      password: password,
    };
    return httpRequest({
      url: url,
      method: "POST",
      data: params,
      headers:{
          "Content-Type": "application/json"
      }
    });
  }
  sendForgotPassword(para) {
    let url =
    sharedGlobals.appUrls.securityApiUrl + "api/Security/SendForgotPassword";
    // let params = {
    //   userEmail: userName,
    //   userEmail: userName,
    // };
  
    return httpRequest({
      url: url,
      method: "POST",
      params : para,
      headers:{
        "Content-Type": "application/json"
      }
    });
  }
  resetPasswordByForgotPasswordKey(userKey,newUserPassword) {
    let url =
      sharedGlobals.appUrls.securityApiUrl + "api/Security/ResetPasswordByForgotPasswordKey";
    let params = {
      UserEncryptedKey:userKey,
      UserNewPassword:newUserPassword,

    };
    return httpRequest({
      url: url,
      method: "POST",
      params : params,
      headers:{
          "Content-Type": "application/json"
      }
    });
  }
  authenticate(username, password) {}
}
let instance = new LoginService();
export default instance;
